// extracted by mini-css-extract-plugin
export default {"dimension-checkbox":"DimensionCheckbox_dimension-checkbox__jMJig"};